import { capitalize } from 'lodash';
import { ValueOf } from '../utilities/types';

const casePriority = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
} as const;

export const ruleCasePriorityChoices = Object.values(casePriority).map((priority) => ({
  id: priority,
  name: capitalize(priority),
}));

export type CasePriority = ValueOf<typeof casePriority>;

export default casePriority;
